import ServerError from './common/ServerError';
import PaymentProvider from './common/PaymentProvider';
import LoadingProgressBar from './common/LoadingProgressBar';
import windowSize from 'react-window-size';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Panel, Well } from 'react-bootstrap';
import _ from 'lodash';
import { caseGetPaymmentHashPublicAction } from '../actions/caseActions';
import Receipt from './Receipt';
import Moment from 'moment';
import { getDateTimeFromUtcInLocalTime } from '../helpers/utils';

class PayFee extends PureComponent {
    constructor(props) {
        super(props);
        this.renderPayState = this.renderPayState.bind(this);
        this.state = {
            loading: true,
            serverError: undefined,
            paid: false,
            account: undefined,
            accountType: 'None',
            amount: undefined,
            country: undefined,
            email: undefined,
            description: undefined,
            invoiceItems: undefined,
            merchantEmail : undefined,
            merchantName : undefined,
            clientName : undefined,
            createdAt: undefined,
        }
    }

    componentDidMount() {
        this.props.dispatch(caseGetPaymmentHashPublicAction(this.props.publicHash))
            .then(result => {
                if (!result) {
                    this.setState({
                        serverError: 'Error retrieving payment information, try reloading the page.',
                        loading: false,
                    });

                    return;
                }

                const hash = result.data;
                this.setState({
                    loading: false,
                    paid: hash.paid,
                    amount: hash.amount,
                    country: hash.country,
                    description: hash.description,
                    invoiceItems: hash.invoiceItems,
                    invoiceId: hash.invoiceId,
                    email: hash.email,
                    account: hash.account,
                    accountType: hash.accountType,
                    merchantEmail: hash.merchantEmail,
                    merchantName: hash.merchantName,
                    clientName: hash.clientName,
                    createdAt: getDateTimeFromUtcInLocalTime(hash.createdAt, { Timezone: Moment.tz.guess() })
                });

            }).catch(error => {
                console.error(new Error().stack, error);
                this.setState({
                    serverError: 'Error while retrieving payment information: ' + error,
                    loading: false,
                });
            })
    }

    renderPayState() {
        let component;
        if (this.state.loading || !this.state.account) {
            component = (<LoadingProgressBar loading />);
        } else if (this.state.paid) {
            component = (
                <React.Fragment>
                <Receipt 
                    clientName={this.state.clientName}
                    merchantName={this.state.merchantName}
                    merchantEmail={this.state.merchantEmail}
                    amount={this.state.amount && (parseInt(this.state.amount, 10) / 100.0).toFixed(2)}
                    country={this.state.country}
                    createdAt={this.state.createdAt}
                    receiptNo={this.props.publicHash}
                    hidden={!this.state.amount || this.state.amount <= 0}
                />
                <PaymentProvider
                    disabled
                    amount={undefined}
                    country={this.state.country}
                    publicHash={this.props.publicHash}
                    description={this.state.description}
                    invoiceItems={this.state.invoiceItems}
                    forceInvoice
                />
                </React.Fragment>
            );

        } else {
            component = (
                <PaymentProvider
                    account={this.state.account}
                    accountType={this.state.accountType}
                    email={this.state.email}
                    onError={error => {this.setState({serverError: error})}}
                    disabled={this.state.amount === undefined}
                    amount={this.state.amount}
                    country={this.state.country}
                    publicHash={this.props.publicHash}
                    description={this.state.description}
                    invoiceItems={this.state.invoiceItems}
                    forceInvoice
                    onSuccess={() => {this.setState({paid: true})}}
                />);
        }

        let header = this.state.paid ? "Invoice" : "Payment";
        if (this.state.invoiceId) {
            header += ` (#${this.state.invoiceId})`;
        }

        return (
            <Row style={{overflow: 'hidden', width: '99%'}}>
            <Col xs={0} md={2} />
            <Col xs={12} md={8} style={{ marginTop: 15, marginBottom: 15 }}>
            <Panel data-hj-whitelist header={header} bsStyle="primary">
            {component}
            </Panel>
            </Col>
            </Row>
        );
    }

    render() {
        const component = this.renderPayState();

        return (
            <React.Fragment>
            {component}
            <ServerError error={this.state.serverError} style='popup' close={() => {this.setState({serverError: undefined})}} />
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let publicHash = state.routing.locationBeforeTransitions.pathname;
    publicHash = publicHash.substring(publicHash.lastIndexOf('/') + 1);
    return {
        publicHash
    }
};

export default connect(mapStateToProps)(windowSize(PayFee));
